import { Card, CardContent, CardHeader, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useNotification } from '../../../../context/NotificationManager/NotificationManager'
import { getNotasProfesorList } from '../../../../utils/api/alumnos'
import { dateToStringLong, dateToTimeString } from '../../../../utils/date'
import PageLoading from '../../../../components/PageLoading/PageLoading'
import css from './NotasProfesor.module.css'

const NotasProfesor = ({ alumnoId }) => {
  const notification = useNotification()

  const { isLoading, data: notasProfesorList = [] } = useQuery({
    queryKey: ['alumnos', 'notas-profesor', 'list', alumnoId],
    queryFn: () =>
      getNotasProfesorList(alumnoId)
        .then(datos => datos.reverse())
        .catch(err => {
          notification.error({
            title: 'Error obteniendo notas de alumno',
            content: err
          })
          return []
        })
  })

  return (
    <PageLoading isLoading={isLoading}>
      {notasProfesorList.length === 0 && (
        <Typography className={css.placeholder} variant='h6'>
          Este alumno no tiene ninguna anotación de profesores en su ficha
        </Typography>
      )}
      {notasProfesorList.map(nota => (
        <div className={css.card} key={nota.id}>
          <Card>
            <CardHeader
              className={css.header}
              title={`${dateToStringLong(nota.fecha)} - ${dateToTimeString(nota.fecha)}`}
              titleTypographyProps={{ variant: 'body1' }}
              subheader={`${nota.usuario} escribió:`}
            />
            <CardContent>
              <Typography variant='body1'>{nota.nota}</Typography>
            </CardContent>
          </Card>
        </div>
      ))}
    </PageLoading>
  )
}

export default NotasProfesor
